/* eslint-disable @typescript-eslint/no-explicit-any */
const StringIsNumber = (value: any) => isNaN(Number(value)) === false

// Turn enum into array
export default function EnumsToArray<T extends object>(e: T): T[] {
  return Object.keys(e)
    .filter(StringIsNumber)
    .map(key => (e as any)[key])
}
